import { HostListener, Injectable } from '@angular/core';
import { now } from 'jquery';
import jwt_decode from 'jwt-decode';
import { Observable, Subject, Subscription } from 'rxjs';

export interface UserInfo {
  username : string|undefined;
  userDisplayname : string|undefined;
  userCompanies : {companyCode : string,companyName : string|undefined,modules : string[]}[] | undefined;
  currentCompany : string|undefined;
  parentUser:string|undefined
  currentCompanyObj : any;
  currentModule : string|undefined;
  userCurrentCompanyModules : string[] | undefined;
  privileges  : string[] | undefined;
  type:any;
  userUid:any;
  personal:any;
}

@Injectable()
export class UserInfoService {
  private userInfo : UserInfo={type:undefined,username : undefined,userDisplayname:undefined,userCompanies : undefined,
                      currentCompany:undefined,currentCompanyObj:undefined,currentModule:undefined,parentUser:undefined,
                      userCurrentCompanyModules:undefined,privileges : undefined,userUid:undefined,personal:undefined};
  private token : string | undefined;
  private userTokenObject : any;
  private tokenExpiry : number| undefined;

  /*private username : string|undefined;
  private userDisplayname : string|undefined;
  private userCompanies : {companyCode : string,companyName : string,modules : string[]}[] | undefined;
  private currentCompany : any;
  private currentModule : string|undefined;
  private userCurrentCompanyModules : string[] | undefined;
  private privileges  : string[] | undefined;*/

  private currentCompanyChangeSubs! : Subject<any>;
  private currentModuleChangeSubs! : Subject<any>;
  private userInfoSubs! : Subject<UserInfo>;

  private subs!: Subscription;

  constructor() { 
    this.subs = new Subscription;
    this.currentCompanyChangeSubs = new Subject<any>();
    this.currentModuleChangeSubs = new Subject<any>();
    this.userInfoSubs = new Subject();
    this.subs.add(this.subscribeCompanyChange());
  }

  onUserCurrentCompanySelect(): void {
   
  }

  onUserCurrentModuleSelect(): void {
   
  }

  subscribeCompanyChange=() => {
    return this.currentCompanyChangeSubs.subscribe({next : () => this.onUserCurrentCompanySelect()});
  }

  subscribeModuleChange=() => {
    return this.currentModuleChangeSubs.subscribe({next : () => this.onUserCurrentModuleSelect()});
  }

  getUserToken(): any {
    return this.token;
  }

  getUserTokenObject() {
    return this.userTokenObject;
  }

  getToken() {
    return this.token;
  }

  getTokenFromSessionCache() : string | null {
    return sessionStorage.getItem("app-fin-auth-token");
  }

  setTokenToSessionCache(token : string|undefined) {
    if(token) sessionStorage.setItem("app-fin-auth-token",token);
  }
  setParentToSessionCache(token : string|undefined) {
    if(token) sessionStorage.setItem("app-fin-auth-token",token);
  }
  getPrivilegesFromSessionCache() : string | null {
    return sessionStorage.getItem("userPrivileges");
  }
  setToken(token : string,) {
    this.token = token;
    this.setTokenToSessionCache(token);
    this.DecodeToken();
  }

  DecodeToken(): any {
    if(this.token) {
      const authTokenDecode : string = jwt_decode(this.token);
      //const tokenData = JSON.parse(authTokenDecode);
      this.userTokenObject=authTokenDecode;

      this.setUserInfo();

      return authTokenDecode;
    }
    return undefined;
  }

  resetAll() {
    this.userInfo.userCompanies=undefined;
    this.userInfo.privileges=undefined;
  }
  setUserInfo() {

    this.resetAll();
    if(this.userTokenObject) {
     
      this.tokenExpiry = this.userTokenObject.exp;
      this.userInfo.username =  this.userTokenObject.sub;
      this.userInfo.userDisplayname=this.userTokenObject.displayName;
      this.userInfo.type=this.userTokenObject.type;
      this.userInfo.userUid=this.userTokenObject.userUid
      this.userInfo.personal=this.userTokenObject.personalBooking

      
      if(this.userTokenObject?.parentToken){
      this.userInfo.parentUser =this.userTokenObject.parentToken;
      }
      
      this.userInfo.privileges = this.userTokenObject?.privs?.split(",");
      if(this.userTokenObject.companies) {
        this.userInfo.userCompanies = this.userTokenObject.companies;
       
        if(this.userTokenObject.currentCompany) {
          this.userInfo.currentCompany = this.userTokenObject.currentCompany;
          this.userInfo.currentCompanyObj=this.userInfo.userCompanies?.find(o => o.companyCode==this.userInfo.currentCompany);

        } else {
          if(this.userInfo.userCompanies && this.userInfo.userCompanies.length==1) {
            this.setCurrentCompany(this.userInfo.userCompanies[0].companyCode);
          } else {
            this.setCurrentCompany(undefined);
          }
        }
        if(this.userTokenObject.currentModule) {
          this.userInfo.currentModule = this.userTokenObject.currentModule;
        }
      }
    }
    this.userInfoSubs.next(this.userInfo)
  }

  isTokenValid() {
    return this.tokenExpiry && this.tokenExpiry <= Date.now();
  }

  getUsername() {
    return this.userInfo.username;
  }
  getParentUser() {
    return this.userInfo.parentUser;
  }

  getUserDisplayname() {
    return this.userInfo.userDisplayname
  }
  getUserType() {
    return this.userInfo.type
  }
  getUserUuid() {
    return this.userInfo.userUid
  }

  getPersonalBooking() {
    return this.userInfo.personal
  }
  getUserCompanies() {
    return this.userInfo.userCompanies;
  }

  getCurrentCompany() {
    return this.userInfo.currentCompany;
  }

  getCurrentComanyObj() {
    return this.userInfo.currentCompanyObj;
  }

  getCurrentModule() {
    return this.userInfo.currentModule;
  }

  setUserCurrentCompanyModules() {
    if(this.userTokenObject && this.userTokenObject.companies && this.userInfo.currentCompany) {
      this.userInfo.userCurrentCompanyModules= this.userTokenObject.companies.find(
        (c: { companyCode: any; })  => c.companyCode==this.userInfo.currentCompany
        )?.modules;
      if(this.userInfo.userCurrentCompanyModules && this.userInfo.userCurrentCompanyModules.length==1) {
        this.setCurrentModule(this.userInfo.userCurrentCompanyModules[0]);
      } else {
        if(this.userInfo.userCurrentCompanyModules?.find(m => m==this.userInfo.currentModule)) {
          this.setCurrentModule(this.userInfo.currentModule);
        }  else {
          this.setCurrentModule(undefined);
        }
      }
    }
  }
  setCurrentCompany(company : string|undefined) {
    this.userInfo.currentCompany =company;
    sessionStorage.setItem("companyCodes",JSON.stringify(company));
    console.log(sessionStorage.getItem("companyCodes"))
    this.userInfo.currentCompanyObj = this.userInfo.userCompanies?.find(o => o.companyCode==company);
    this.currentCompanyChangeSubs.next({currentCompany :this.userInfo.currentCompany,currentCompanyObj :this.userInfo.currentCompanyObj});
    this.setUserCurrentCompanyModules();
  }

  getCurrentCompanyChangeSubs() {
    return this.currentCompanyChangeSubs.asObservable();
  }

  getCurrentModuleChangeSubs() {
    return this.currentModuleChangeSubs.asObservable();
  }

  setCurrentModule(module : string | undefined) {
    this.userInfo.currentModule = module;
    this.currentModuleChangeSubs.next({currentModule :this.userInfo.currentModule})
  }

  getPrivileges() {
    // console.log(this.userInfo.privileges)
    return this.userInfo.privileges;
  }

  setUserPrivileges(userPrivileges:any){
  // console.log(userPrivileges)
     this.userInfo.privileges=userPrivileges;
     this.setPrivilegesToSessionCache(userPrivileges)
   }
   setPrivilegesToSessionCache(privileges : any|undefined) {
    if(privileges) sessionStorage.setItem("userPrivileges",privileges);
  }
  getUserInfoSubs() :Observable<UserInfo>{
    return this.userInfoSubs.asObservable();
  }

  isPriv(privName : string) {
    this.userInfo.privileges?.find(o => o==privName) ? true : false;
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event : any) {
    this.subs.unsubscribe();
  }
}
